import { CdFilterPanel, type OptionGroup } from '../CdFilterPanel';

export interface CdManageColumnsPanelProps {
  open: boolean;
  onClose: () => void;
  /** Column groups; each option is a column and `checked` means visible. */
  groups: OptionGroup[];
  onToggleColumn: (groupId: string, columnId: string, visible: boolean) => void;
  title?: string;
}

/** "Manage Columns" panel – column visibility grouped by setting (Figma index page). */
export const CdManageColumnsPanel = ({
  open,
  onClose,
  groups,
  onToggleColumn,
  title = 'Manage columns',
}: CdManageColumnsPanelProps) => {
  return (
    <CdFilterPanel
      open={open}
      onClose={onClose}
      title={title}
      groups={groups}
      onOptionChange={onToggleColumn}
      defaultOpenGroups={groups.map((g) => g.id)}
    />
  );
};
